import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * The billing address type.
 */

/**
 * Gets the billing address for a subscription.
 * @param subsWithMop - The subscription with the method of payment.
 * @returns The billing address.
 */
export var getBillingAddress = function getBillingAddress(subsWithMop) {
  var _subsWithMop$myLatest;
  var methodOfPayment = (_subsWithMop$myLatest = subsWithMop.myLatestSubscriptionsV1) === null || _subsWithMop$myLatest === void 0 || (_subsWithMop$myLatest = _subsWithMop$myLatest.cheggStudy) === null || _subsWithMop$myLatest === void 0 || (_subsWithMop$myLatest = _subsWithMop$myLatest.subscription) === null || _subsWithMop$myLatest === void 0 ? void 0 : _subsWithMop$myLatest.methodOfPayment;
  if (!methodOfPayment) return undefined;
  var billingAddress = methodOfPayment.billingAddress,
    mopHolderName = methodOfPayment.mopHolderName;
  var fname = (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.firstName) || '';
  var lname = (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.lastName) || '';
  if (mopHolderName && !fname) {
    var _mopHolderName$split = mopHolderName.split(' ');
    var _mopHolderName$split2 = _slicedToArray(_mopHolderName$split, 2);
    fname = _mopHolderName$split2[0];
    lname = _mopHolderName$split2[1];
  }
  return {
    fname: fname,
    lname: lname,
    country: (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.country) || '',
    city: (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.city) || '',
    state: (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.state) || '',
    zip: (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.postalCode) || '',
    active: 1,
    category: 'default'
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/PRSUtils/nextInteractionUtil/getBillingAddress.js
// module id = 4160
// module chunks = 11